import { HttpClient, HttpEvent, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, map, Observable } from 'rxjs';
import { IFile } from '../models/i-file';
import { IFileUploadResult } from '../models/i-file-upload-result';
import { environment } from '../../../environments/environment';
import { IFileUploadRequest } from '../models/i-file-upload-request';
import { OTHER_OPTION } from '../../core/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class FileService {

 constructor(
    private http: HttpClient,
    private activatedRoute: ActivatedRoute
  ) { }

  private getQueryStringParam(): string {
    // Get 's' parameter from current route
    let sParam = '';
    this.activatedRoute.queryParams.subscribe(params => {
      sParam = params['s'] || '';
    });
    return sParam;
  }

  deleteFile(file: IFile): Observable<boolean> {
    const params = new HttpParams().set('s', this.getQueryStringParam());

    return this.http.post<boolean>('/api/AssessmentForms/DeleteFile', file, { params }).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error deleting file:', error);
        throw error;
      })
    );
  }

  uploadFile(uploadData: IFileUploadRequest): Observable<HttpEvent<IFileUploadResult>> { 


    const formData = new FormData();  
    
        formData.append('matterId', uploadData.matterId ?? '');
        formData.append('type', uploadData.type ?? '');
        formData.append('description', uploadData.description ?? '');
        formData.append('fileId', uploadData.fileId ?? '');
        formData.append('file', uploadData.file);
          

  return this.http.post<IFileUploadResult>(
    `${environment.apiUrl}/AssessmentForms/UploadAssessmentFile`, 
    formData,
    {
      reportProgress: true,
      observe: 'events'
    }
  );
  }}
